export function labelForType(type) {
  switch(type) {
    case "bail_locataire": return "Bail signé par le locataire";
    case "bail_bailleur": return "Bail signé par le bailleur";
    case "etat_des_lieux": return "État des lieux";
    case "inventaire_mobilier": return "Inventaire du mobilier";
    case "avenant": return "Avenant au bail";
    default: return "Document";
  }
}